import {useQuery} from '@tanstack/react-query'
import {useApi} from '../api/ApiContext'

export const PORTFOLIO_POLL_MS = 60_000

export function usePortfolioState() {
  const api = useApi()
  return useQuery({
    queryKey: ['portfolio-dashboard'],
    queryFn: () => api.portfolioDashboard(),
    refetchInterval: PORTFOLIO_POLL_MS,
    staleTime: 55_000,
  })
}
